export default "__VITE_ASSET__CDnmp26i__"